import { HTMLAttributes, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'var(--bui-bg-surface-1)',
    padding: 'var(--bui-space-1) var(--bui-space-2)',
    borderRadius: 'var(--bui-radius-2)',
    flexWrap: 'wrap',
    gap: 'var(--bui-space-1)',
  },
  noWrap: {
    flexWrap: 'nowrap',
  },
});

export interface ExpressionGroupProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {
  disableWrap?: boolean;
}

const ExpressionGroup = forwardRef<HTMLDivElement, ExpressionGroupProps>(
  (props, ref) => {
    const { classes, className, disableWrap, style, ...rest } = props;
    return (
      <div
        ref={ref}
        className={classNames(
          className,
          classes.root,
          disableWrap && classes.noWrap,
        )}
        style={style}
        {...rest}
      />
    );
  },
);

ExpressionGroup.displayName = 'Expression.Group';

export default withStyles(styles)(ExpressionGroup);
